module.exports = __webpack_public_path__ + "static/william-ee470b17a75e956154d9295850352839.jpg";